import type React from 'react';

import { tailwindMerge } from '../../tailwind';

export const CommonSvg = ({
  className,
  ...props
}: React.ComponentProps<'svg'>) => {
  return (
    <svg
      className={tailwindMerge('align-middle focus:outline-hidden', className)}
      style={props.width ? { minWidth: `${props.width}px` } : {}}
      {...props}
    />
  );
};
